// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b7a3d43f","111":"5df50804","358":"818e444a","378":"19d93927","481":"1814bfa4","522":"baee81c7","593":"3e19b8f9","607":"56efc6f0","621":"65404811","688":"4bf0216d","719":"8525d731","988":"4830158e"}[chunkId] + ".chunk.js";
};